export const TODO_ACTIONS = {
  ADD_ITEM: "ADD_ITEM",
  REMOVE_ITEM: "REMOVE_ITEM",
  CHECK_ITEM: "CHECK_ITEM",
  UPDATE_ITEM: "UPDATE_ITEM",
  ACCEPT_ITEM: "ACCEP_ITEM",
};
